// extracted by mini-css-extract-plugin
export default {"footer":"index_footer__CbNuz","links":"index_links__ZbdR1","version":"index_version__uhnCR"};